import React from "react";
import "./dashboard.scss";

const stats = [
  { label: "Total Leads", value: "1,248", trend: "↑ 12.5%", note: "vs last week", icon: "♙", tone: "red" },
  { label: "New Leads", value: "320", trend: "↑ 8.3%", note: "vs last week", icon: "▤", tone: "yellow" },
  { label: "Approved Leads", value: "145", trend: "↑ 15.7%", note: "vs last week", icon: "✓", tone: "blue" },
  { label: "Merged Leads", value: "11.6%", trend: "↑ 2.1%", note: "vs last week", icon: "↗", tone: "green" },
];

const leadRows = [
  { name: "Juan Dela Cruz", company: "ABC Construction", source: "Website", date: "May 18, 2024", status: "New" },
  { name: "Maria Santos", company: "BuildWell Corp.", source: "Referral", date: "May 18, 2024", status: "Contacted" },
  { name: "Pedro Reyes", company: "SteelPro Builders", source: "Social Media", date: "May 17, 2024", status: "Qualified" },
  { name: "Ana Garcia", company: "Mega Structures Inc.", source: "Website", date: "May 17, 2024", status: "New" },
  { name: "Chris Lim", company: "Prime Constructions", source: "Email", date: "May 16, 2024", status: "Contacted" },
];

const sources = [
  { label: "myBina", value: 48 },
  { label: "The Star", value: 22 },
  { label: "Sin Chew", value: 18 },
  { label: "Berita Harian", value: 12 },
  { label: "Manual Insert", value: 3 },
];

const DashboardPage = () => {
  return (
    <div className="dashboard-page">
      <section className="dashboard-page__hero">
        <div>
          <h2>Welcome back, Admin! 👋</h2>
          <p>Here’s what’s happening with your business today.</p>
        </div>
      </section>

      <section className="dashboard-page__stats">
        {stats.map((item) => (
          <article className="dashboard-page__stat-card" key={item.label}>
            <div className={`dashboard-page__stat-icon dashboard-page__stat-icon--${item.tone}`}>
              {item.icon}
            </div>
            <div>
              <p>{item.label}</p>
              <h3>{item.value}</h3>
              <span>{item.trend}</span> <small>{item.note}</small>
            </div>
          </article>
        ))}
      </section>

      <section className="dashboard-page__analytics-grid">
        <article className="dashboard-page__panel dashboard-page__panel--chart">
          <div className="dashboard-page__panel-header">
            <h3>Leads Overview</h3>
            <button type="button">This Week ⌄</button>
          </div>

          <div className="dashboard-page__legend">
            <span><i className="dashboard-page__legend-red" /> New Leads</span>
            <span><i className="dashboard-page__legend-blue" /> Converted Leads</span>
          </div>

          <div className="dashboard-page__line-chart" aria-label="Leads overview chart">
            <svg viewBox="0 0 760 220" role="img">
              <defs>
                <linearGradient id="leadFill" x1="0" x2="0" y1="0" y2="1">
                  <stop offset="0%" stopColor="#ed1c24" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#ed1c24" stopOpacity="0" />
                </linearGradient>
              </defs>
              {[40, 80, 120, 160, 200].map((y) => (
                <line key={y} x1="0" x2="760" y1={y} y2={y} />
              ))}
              <path className="dashboard-page__area" d="M0,178 L110,140 L220,115 L330,100 L440,55 L550,88 L650,130 L760,165 L760,220 L0,220 Z" />
              <polyline className="dashboard-page__line-red" points="0,178 110,140 220,115 330,100 440,55 550,88 650,130 760,165" />
              <polyline className="dashboard-page__line-blue" points="0,198 110,165 220,135 330,128 440,112 550,135 650,125 760,188" />
              {["0,178", "110,140", "220,115", "330,100", "440,55", "550,88", "650,130", "760,165"].map((point) => {
                const [cx, cy] = point.split(",");
                return <circle key={point} className="dashboard-page__dot-red" cx={cx} cy={cy} r="5" />;
              })}
              {["0,198", "110,165", "220,135", "330,128", "440,112", "550,135", "650,125", "760,188"].map((point) => {
                const [cx, cy] = point.split(",");
                return <circle key={point} className="dashboard-page__dot-blue" cx={cx} cy={cy} r="5" />;
              })}
            </svg>
            <div className="dashboard-page__chart-labels">
              <span>May 12</span><span>May 13</span><span>May 14</span><span>May 15</span><span>May 16</span><span>May 17</span><span>May 18</span>
            </div>
          </div>
        </article>

        <article className="dashboard-page__panel dashboard-page__panel--source">
          <h3>Leads by Source</h3>
          <div className="dashboard-page__source-content">
            <div className="dashboard-page__donut">
              <div><strong>103</strong><span>Total</span></div>
            </div>
            <div className="dashboard-page__source-list">
              {sources.map((source) => (
                <div key={source.label}>
                  <span><i className={source.className} /> {source.label}</span>
                  <strong>{source.value}</strong>
                </div>
              ))}
            </div>
          </div>
        </article>
      </section>

      <section className="dashboard-page__bottom-grid">
        <article className="dashboard-page__panel">
          <div className="dashboard-page__panel-header">
            <h3>Recent Leads</h3>
            <button type="button">View All</button>
          </div>
          <div className="dashboard-page__table-wrap">
            <table>
              <thead>
                <tr><th>Name</th><th>Company</th><th>Source</th><th>Date</th><th>Status</th></tr>
              </thead>
              <tbody>
                {leadRows.map((lead) => (
                  <tr key={`${lead.name}-${lead.date}`}>
                    <td>{lead.name}</td>
                    <td>{lead.company}</td>
                    <td>{lead.source}</td>
                    <td>{lead.date}</td>
                    <td><span className={`dashboard-page__status dashboard-page__status--${lead.status.toLowerCase()}`}>{lead.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </article>
      </section>
    </div>
  );
};

export default DashboardPage;
